import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbookLineageCountsFragmentGql } from './WorkbookLineageCountsFragmentGql';

export const WorkbookLineageCountsQueryGql: DocumentNode = gql`
query WorkbookLineageCountsQuery($workbookVizportalUrlId: String!, $publishedConnectionsLineageEnabled: Boolean!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    ...WorkbookLineageCountsFragment
  }
}
${WorkbookLineageCountsFragmentGql}
`;
